//@flow
import React from 'react';
import Popover from '../Popover';
import {
  CategoryQueryVAB,
  CategoryWiseDetail,
  FacetedItemInfo,
  GetFacetsMsg,
  GetFacetsQuery,
  GetFacetsRes
} from '../autogenerated/ZoomBridge';
import _ from 'lodash';
import ErrorHandler from '../error/ErrorHandler';
import $ from 'jquery';
import StringUtil from '../util/StringUtil';
import Div from './elements/Div';
import { getLabelWithoutCount } from '../util/FacetUtil';
import Store from '../store/Store';
import { GLOBAL_SEARCH_INFO } from '../store/Constants';
import { ThemeSetup } from '../themes/ThemeSetup';

const debug = require('../debug/debug')('wc:common:MultiSelect');

type Props = {
  category: CategoryWiseDetail,
  onCategoryChangeEvent: (
    categoryId: string,
    selected: boolean,
    option: FacetedItemInfo,
    parent: FacetedItemInfo
  ) => void
};

export default class MultiSelect extends React.Component<Props, {}> {
  UNSAFE_componentWillMount() {
    this.delayedIssueFacetsQuery = _.debounce((value) => {
      this.issueFacetsQuery(value);
    }, 300);
  }

  render() {
    const { category } = this.props;
    var header;
    var skipParent = category.getCategoryId() === 'metadata_key' || category.getCategoryId() === 'metadata_value';
    let __tooltip;

    if (category.getCategoryId() === 'metadata_key') {
      const __item = _.find(category.getName2count(), (option) => option.getParentId() <= 0);
      header = __item.getDisplayLabel();
      __tooltip = getLabelWithoutCount(__item);
    } else {
      header = getLabelWithoutCount(category);
    }

    const color = category.isHasAnySelectedItem() ? 'var(--primary-style-color)' : 'var(--primary-font-color)';
    const iconUp = category.isHasAnySelectedItem()
      ? ThemeSetup.getBackgroundURL('arrow_up_red.svg')
      : 'url(images/arrow_up.svg)';
    const iconDown = category.isHasAnySelectedItem()
      ? ThemeSetup.getBackgroundURL('arrow_down_red.svg')
      : 'url(images/arrow_down.svg)';
    const value = category.getMatchString() || '';
    return (
      <div style={{ float: 'left', marginRight: '10px', marginBottom: '10px' }} ref="select" name="MultiSelect">
        <Div
          title={__tooltip}
          style={{
            ...styles.select,
            color,
            backgroundColor: category.isOpened ? 'var(--dropdown-bg-selected)' : 'var(--primary-header-bg)',
            backgroundImage: category.isOpened ? iconUp : iconDown
          }}
          onClick={() => {
            category.isOpened = true;
            window.render();
            setTimeout(
              function() {
                $(this.refs.filter).focus();
              }.bind(this),
              0
            ); // sync execution doesnt focus this field for some reason
          }}>
          {header}
        </Div>
        {category.isOpened ? (
          <Popover
            left={this.refs.select ? this.refs.select.getBoundingClientRect().left : 0}
            top={this.refs.select ? this.refs.select.getBoundingClientRect().bottom : 0}
            onClose={() => {
              category.isOpened = false;
              window.render();
            }}>
            <div style={styles.options}>
              {category.getName2count().length >= 6 || value ? (
                <div style={{ borderBottom: '1px solid #E7E7E7', background: 'var(--primary-header-bg)' }}>
                  <input
                    ref="filter"
                    onChange={(event) => {
                      // getting the input value via event.target.value (there was ref="filterInput", which shouldn't be used for getting values)
                      category.setMatchString(event.target.value); // on the client change the value instantly without debouncing
                      window.render();
                      this.delayedIssueFacetsQuery(event.target.value); // send a request only after a certain delay
                    }}
                    value={value}
                    placeholder="Filter"
                    style={styles.filter}
                    type="text"
                  />
                </div>
              ) : null}
              {_.map(category.getName2count(), (option, index) => this.renderOption(option, index, skipParent))}
            </div>
          </Popover>
        ) : null}
      </div>
    );
  }

  issueFacetsQuery(matchString) {
    let prop = null;
    const { category } = this.props;
    const facetQuery = new GetFacetsQuery();
    const msg = new GetFacetsMsg();
    msg.setUseCurrentFuidSet(true);
    facetQuery.message = msg;
    msg._useCategoryListForResponse = true;
    const cv = new CategoryQueryVAB();
    cv._matchString = matchString;
    cv._kidsQuery = true;

    if (category.getCategoryId() == 'metadata_key') {
      prop = _.find(category.getName2count(), (option) => option.getParentId() <= 0);
      cv._parentIdName = prop.getLabel();
      //cv._parentIdName = propLabel.substr(0, propLabel.lastIndexOf(' ('));
    }

    cv._categoryId = category.getCategoryId();

    msg._categoryList = [cv];
    debug('[issueFacetsQuery()] running query: ', facetQuery);
    facetQuery.run().then(
      (resp: GetFacetsRes) => {
        debug('[issueFacetsQuery()] response: ', resp);
        const __categoryList = resp.getCategoryList();
        if (__categoryList[0]) {
          this.props.category.setName2count(__categoryList[0].getName2count());
          window.render();
        } else {
          this.props.category.setName2count([prop]);
          window.render();
        }
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }

  getParentNode(input: FacetedItemInfo): ?FacetedItemInfo {
    const category: CategoryWiseDetail = this.props.category;
    let resItem: FacetedItemInfo = undefined;
    const parentId = input.getParentId();
    if (parentId > 0) {
      const options: Array<FacetedItemInfo> = category.getName2count();
      resItem = options.find(function(item: FacetedItemInfo) {
        if (item.getId() == parentId) return true;
      });
    }
    return resItem;
  }

  onCategoryChange(option: FacetedItemInfo) {
    const { category } = this.props;
    option.setSelected(!option.isSelected());
    const parentNode: ?FacetedItemInfo = this.getParentNode(option);
    this.props.onCategoryChangeEvent(category.getCategoryId(), option.isSelected(), option, parentNode);
    window.render();
  }

  renderOptionLabel(option: FacetedItemInfo) {
    const globalSearchInfo: Object = Store.get(GLOBAL_SEARCH_INFO);
    let label;
    if (globalSearchInfo.active) {
      label = StringUtil.isNotEmpty(option.getDisplayLabel()) ? option.getDisplayLabel() : option.getLabel();
//      label += ' (' + option.getCount() + ')';
    } else {
      label = StringUtil.isNotEmpty(option.getDisplayLabel()) ? option.getDisplayLabel() : getLabelWithoutCount(option);
    }
    label = label.replace(/\*/g, String.fromCharCode(9733));
    return (
      <div
        style={{
          left: '30px',
          // position: 'absolute',
          color: 'var(--primary-font-color)',
          paddingLeft: '10px',
          textAlign: 'justify'
        }}>
        {label}
      </div>
    );
  }

  renderOption(option: FacetedItemInfo, index: number, skipParent: boolean) {
    if (option == null || option.getId() == -555 || (skipParent && option.getParentId() <= 0)) {
      return null;
    }

    return (
      <div
        key={option.getLabel() + '-' + index}
        onClick={(event) => this.onCategoryChange(option)}
        style={styles.option}>
        <img
          src={
            option.isSelected()
              ? ThemeSetup.getImageURL('icon_radio_checked.svg')
              : ThemeSetup.getImageURL('radio_unchecked.svg')
          }
          style={{ height: '16px', cursor: 'pointer' }}
        />
        {this.renderOptionLabel(option)}
      </div>
    );
  }
}

const styles = {
  select: {
    padding: '6px 30px 6px 10px',
    minWidth: '130px',
    fontSize: '14px',
    cursor: 'pointer',
    height: '33px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(100% - 10px) 15px',
    borderRadius: '3px',
    boxShadow: '0 1px 4px -2px rgba(0,0,0,0.10)'
  },
  option: {
    cursor: 'pointer',
    padding: '10px',
    fontSize: '12px',
    // position: 'relative',
    display: 'flex'
    // height: 'auto'
  },
  filter: {
    outline: 'none',
    border: 'none',
    fontSize: '14px',
    width: '100%',
    padding: '10px 10px 10px 12px'
  },
  options: {
    boxShadow: '0 15px 30px -10px rgba(0,0,0,0.20)',
    position: 'fixed',
    zIndex: '2',
    background: 'var(--primary-header-bg)',
    width: '400px',
    overflowY: 'auto',
    maxHeight: '80%'
  }
};
